<div class="modal-overlay"></div>
<div
  class="modal"
  tabindex="-1"
  [ngClass]="{ show: opened, fade: opened }"
  [ngStyle]="{ display: opened ? 'block' : 'none' }"
>
  <div style="text-align: center">
    <div>
      <br><br><br><br><br><br><br><br><br><br>
      <img src="assets/images/loading.gif" style="width: 100px; height: 100px;"/>
      <br>
      <span style="color: white;">Cargando...</span>
    </div>
  </div>
</div>
